/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Lot_Trace_Field_AromaInputs */

const vi_order_lot_trace_field_aroma = /** @type {(inputs: Order_Lot_Trace_Field_AromaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hương`)
};

/**

* @param {Order_Lot_Trace_Field_AromaInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_lot_trace_field_aroma = /** @type {((inputs?: Order_Lot_Trace_Field_AromaInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Lot_Trace_Field_AromaInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_lot_trace_field_aroma(inputs)
});